import { EOTPType } from '../api/account/request-otp';
import { ELoginMethod } from '../api/user/types';
import { getDialCodeFromCountryKey } from './country';

export const mapLoginSubTabToOTPType = (subTab: ELoginMethod) => {
  switch (subTab) {
    case ELoginMethod.EMAIL:
      return EOTPType.EMAIL;
    case ELoginMethod.SMS:
      return EOTPType.SMS;
    default:
      return null;
  }
};

export interface ILoginCredentialsFormValue {
  userId?: string;
  password?: string;
  email?: string;
  phoneNumber?: string;
  countryKey?: string;
  verificationCode?: string;
}

interface IGetLoginCredentialsParams extends ILoginCredentialsFormValue {
  loginMethod?: ELoginMethod;
}

/**
 * Gets the login credentials for the given sub tab.
 *
 * @param params.userId - The user ID.
 * @param params.password - The password.
 * @param params.email - The email.
 * @param params.phoneNumber - The phone number.
 * @param params.dialCode - The dial code.
 * @param params.verificationCode - The verification code.
 * @param params.loginSubTab - The login sub tab.
 *
 * @returns The login credentials.
 */
export const getLoginCredentials = (params: IGetLoginCredentialsParams) => {
  const { loginMethod, userId, password, email, phoneNumber, countryKey, verificationCode } = params;

  if (!loginMethod) {
    return {
      userId,
      password
    };
  }

  const CREDENTIALS: Record<ELoginMethod, () => { userId?: string; password?: string }> = {
    [ELoginMethod.EMAIL]: () => ({ userId: email, password: verificationCode }),
    [ELoginMethod.SMS]: () => ({
      userId: `${getDialCodeFromCountryKey(countryKey)}-${phoneNumber}`,
      password: verificationCode!
    }),
    [ELoginMethod.PASSWORD]: () => ({ userId, password })
  };

  return CREDENTIALS[loginMethod]?.();
};
